import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "../../Utils/helper";


export const PollResultBlock = ({ questions = [], usesvoteCount = [] }) => {

    const { campaignSettings } = useSelector( state => ({ campaignSettings: state.campaignSettings }) );

    const { totalVote, voteCount } = campaignSettings?.defaultContent;

    const { fontSize } = campaignSettings;

    const ParSize = {
        "small":"text-sm",
        "medium":"text-base",
        "large":"text-[18px]"
    }

    const totalVoltSize = {
        "small":"text-[18px]",
        "medium":"text-[20px]",
        "large":"text-[24px]" 
    }

    const totalVoltNUMSize = {
        "small":"text-[40px]",
        "medium":"text-[60px]",
        "large":"text-[60px]" 
    }

    const ratingRange5 = [1, 2, 3, 4, 5];
    
    const ratingRange10 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

    const [maxvoteCount, setMaxVoteCount] = useState(0);

    const yesOrNo = [
        {
            icon: (<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="70" height="70" rx="35" fill="#49D57A" />
                <path d="M32.3582 45.5C32.0128 45.5003 31.6708 45.4323 31.3517 45.3001C31.0326 45.1678 30.7428 44.9739 30.4988 44.7294L22.6089 36.8395C22.1317 36.343 21.8683 35.6793 21.8751 34.9908C21.882 34.3022 22.1585 33.6438 22.6454 33.157C23.1323 32.6701 23.7907 32.3936 24.4793 32.3868C25.1678 32.38 25.8315 32.6435 26.3279 33.1207L32.1811 38.9738L43.4882 25.4053C43.9398 24.8855 44.5772 24.5635 45.2636 24.5084C45.95 24.4534 46.6306 24.6695 47.1593 25.1106C47.6881 25.5517 48.0229 26.1825 48.0918 26.8676C48.1607 27.5527 47.9583 28.2375 47.5279 28.7751L34.3782 44.555C34.1444 44.8356 33.8546 45.0644 33.5273 45.2267C33.2 45.389 32.8425 45.4813 32.4776 45.4976C32.4378 45.5 32.398 45.5 32.3582 45.5Z" fill="white" />
            </svg>
            ),
            type: "yes"
        },
        {
            icon: (<svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="70" height="70" rx="35" fill="#DC2626" />
                <path d="M38.7003 35L44.7196 28.9874C44.9658 28.7445 45.1615 28.4553 45.2955 28.1366C45.4294 27.8178 45.4989 27.4757 45.5 27.1301C45.5011 26.7844 45.4337 26.4419 45.3018 26.1223C45.1698 25.8027 44.9759 25.5123 44.7312 25.2679C44.4865 25.0234 44.1958 24.8298 43.8758 24.698C43.5559 24.5662 43.213 24.4989 42.8669 24.5C42.5208 24.5011 42.1784 24.5706 41.8593 24.7044C41.5402 24.8382 41.2507 25.0337 41.0076 25.2797L34.9883 31.2921L28.9691 25.2797C28.4753 24.7953 27.8101 24.5254 27.1181 24.5285C26.4261 24.5316 25.7633 24.8076 25.274 25.2964C24.7847 25.7852 24.5084 26.4472 24.5052 27.1384C24.5021 27.8297 24.7724 28.4942 25.2572 28.9874L31.2763 35L25.2571 41.0125C24.77 41.5053 24.4978 42.1705 24.5 42.863C24.5022 43.5555 24.7786 44.219 25.2688 44.7087C25.759 45.1984 26.4233 45.4744 27.1166 45.4766C27.8098 45.4787 28.4758 45.2068 28.9691 44.7203L34.9883 38.7078L41.0076 44.7204C41.2507 44.9664 41.5402 45.1619 41.8593 45.2957C42.1784 45.4295 42.5209 45.4989 42.867 45.5C43.213 45.5011 43.5559 45.4338 43.8759 45.302C44.1958 45.1702 44.4865 44.9765 44.7312 44.732C44.9759 44.4876 45.1698 44.1972 45.3017 43.8776C45.4337 43.558 45.501 43.2155 45.4999 42.8698C45.4988 42.5241 45.4293 42.1821 45.2953 41.8633C45.1614 41.5446 44.9656 41.2554 44.7194 41.0125L38.7003 35Z" fill="white" />
            </svg>
            ),
            type: "no"
        }
    ]

    useEffect(() => {

        let max = 0;

        usesvoteCount?.map((obj) => { if (obj?.total > max) max = obj?.total; });

        setMaxVoteCount(max);

    }, [])

    return (
        <div className="w-full h-full m-auto flex flex-col">

            <p className={` m-auto font-bold capitalize ${totalVoltSize[fontSize]} `} >{ totalVote ?? "Total vote" }</p>

            <p className={` ${totalVoltNUMSize[fontSize]} m-auto font-bold `} >{maxvoteCount}</p>

            <div className="w-full flex flex-wrap space-y-5 ">
                {questions?.map((list, index) => {

                    if (list?.optionType !== "email") return (
                        <div className="w-full mx-auto space-y-7 bg-white border-1 h-full rounded-xl p-8">
                            <p className={`w-full transition-all duration-700  mb-2 font-medium mx-auto whitespace-nowrap overflow-hidden text-ellipsis text-black ${ParSize[fontSize]}`}>{list?.question}</p>
                            <div className="w-full flex flex-col  space-y-4">
                                {
                                    list?.optionType == "multioption" ?
                                        list?.options?.map((listoption, Innerindex) => {
                                            let PollVotePer = (usesvoteCount[index]?.option[Innerindex] / usesvoteCount[index]?.total) * 100
                                            if (isEmpty(PollVotePer) || isNaN(PollVotePer)) PollVotePer = 0
                                            return (
                                                <div className="flex w-full space-x-6">
                                                    <p className={`flex  min-h-[75px] bg-primary rounded-full font-semibold min-w-[75px] my-auto p-2 py-3 text-black ${ParSize[fontSize]}`}><span className="flex m-auto max-w-full text-white">{(isEmpty(PollVotePer) || isNaN(PollVotePer) ? "0.0" : PollVotePer.toFixed(1))}%</span></p>
                                                    <div className="w-full space-y-3 ">
                                                        <p className={`${ParSize[fontSize]} w-full flex justify-between transition-all duration-700  font-medium mx-auto text-black`}><span>{listoption}</span></p>
                                                        <div className={`w-full  h-2  bg-[rgba(37,99,235,0.1)] rounded-full  grid justify-items-start `} >
                                                            <div className={` h-2 w-[10%] transition-all duration-500  bg-primary rounded-full `} style={{ width: `${PollVotePer}%` }} ></div>
                                                        </div>
                                                    </div>

                                                </div>
                                            )

                                        }) :
                                        list?.optionType == "starrating" ?
                                            ratingRange5?.map((listoption, Innerindex) => {
                                                let PollVotePer = (usesvoteCount[index]?.option[Innerindex] / usesvoteCount[index]?.total) * 100
                                                if (isEmpty(PollVotePer) || isNaN(PollVotePer)) PollVotePer = 0
                                                return (
                                                    <div className="flex w-full space-x-6">
                                                        <p className={`flex  min-h-[75px] bg-primary rounded-full font-semibold min-w-[75px] my-auto p-2 py-3 text-black ${ParSize[fontSize]} `}><span className="flex m-auto max-w-full text-white">{(isEmpty(PollVotePer) || isNaN(PollVotePer) ? "0.0" : PollVotePer.toFixed(1))}%</span></p>
                                                        <div className="w-full space-y-3 ">
                                                            <p className={` ${ParSize[fontSize]} w-full flex space-x-2 transition-all duration-700  font-medium mx-auto text-black `}>
                                                                <span>{listoption}</span>
                                                                <span  >
                                                                    <svg width={"28"} height={"28"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                                                        <path d="M12.0001 17.27L16.1501 19.78C16.9101 20.24 17.8401 19.56 17.6401 18.7L16.5401 13.98L20.2101 10.8C20.8801 10.22 20.5201 9.12001 19.6401 9.05001L14.8101 8.64001L12.9201 4.18001C12.5801 3.37001 11.4201 3.37001 11.0801 4.18001L9.19007 8.63001L4.36007 9.04001C3.48007 9.11001 3.12007 10.21 3.79007 10.79L7.46007 13.97L6.36007 18.69C6.16007 19.55 7.09007 20.23 7.85007 19.77L12.0001 17.27Z"
                                                                            fill={"#ffffff"} stroke={"#2563EB"} strokeWidth={2} />
                                                                    </svg>
                                                                </span>
                                                            </p>
                                                            <div className={`w-full  h-2  bg-[rgba(37,99,235,0.1)] rounded-full  grid justify-items-start `} >
                                                                <div className={` h-2 w-[10%] transition-all duration-500  bg-primary rounded-full `} style={{ width: `${PollVotePer}%` }} ></div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                )

                                            }) :
                                            list?.optionType == "rating" ?
                                                ratingRange10?.map((listoption, Innerindex) => {
                                                    let PollVotePer = (usesvoteCount[index]?.option[Innerindex] / usesvoteCount[index]?.total) * 100
                                                    if (isEmpty(PollVotePer) || isNaN(PollVotePer)) PollVotePer = 0
                                                    return (
                                                        <div className="flex w-full space-x-6">
                                                            <p className={` flex  min-h-[75px] bg-primary rounded-full font-semibold min-w-[75px] my-auto p-2 py-3 text-black ${ParSize[fontSize]} `}><span className="flex m-auto max-w-full text-white">{(isEmpty(PollVotePer) || isNaN(PollVotePer) ? "0.0" : PollVotePer.toFixed(1))}%</span></p>
                                                            <div className="w-full space-y-3 ">
                                                                <p className={` ${ParSize[fontSize]} w-full flex space-x-2 transition-all duration-700  font-medium mx-auto text-black`}>
                                                                    <span>{listoption}</span>
                                                                </p>
                                                                <div className={`w-full  h-2  bg-[rgba(37,99,235,0.1)] rounded-full  grid justify-items-start `} >
                                                                    <div className={` h-2 w-[10%] transition-all duration-500  bg-primary rounded-full `} style={{ width: `${PollVotePer}%` }} ></div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    )

                                                }) :
                                                yesOrNo?.map((listoption, Innerindex) => {
                                                    let PollVotePer = (usesvoteCount[index]?.option[Innerindex] / usesvoteCount[index]?.total) * 100
                                                    if (isEmpty(PollVotePer) || isNaN(PollVotePer)) PollVotePer = 0
                                                    return (
                                                        <div className="flex w-full space-x-6">
                                                            <p className={`flex  min-h-[75px] bg-primary rounded-full font-semibold min-w-[75px] my-auto p-2 py-3 text-black ${ParSize[fontSize]}`}><span className="flex m-auto max-w-full text-white">{(isEmpty(PollVotePer) || isNaN(PollVotePer) ? "0.0" : PollVotePer.toFixed(1))}%</span></p>
                                                            <div className="w-full space-y-3 ">
                                                                <p className={` ${ParSize[fontSize]} w-full flex justify-between transition-all duration-700  font-medium mx-auto text-black `}><span>{listoption?.type}</span></p>
                                                                <div className={`w-full  h-2  bg-[rgba(37,99,235,0.1)] rounded-full  grid justify-items-start `} >
                                                                    <div className={` h-2 w-[10%] transition-all duration-500  bg-primary rounded-full `} style={{ width: `${PollVotePer}%` }} ></div>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    )

                                                })
                                }

                            </div>
                            <div className="w-full flex justify-end items-center transition-all text-sm font-medium   text-[#232224]">{ voteCount ?? "Vote Count"} : {usesvoteCount[index]?.total ?? 0}</div>

                        </div>
                    )
                })}
            </div>
        </div>
    )

}